import { makeStyles } from '@material-ui/core/styles'

import palette from 'theme/palette'

const useBulkGoalStyles = makeStyles(theme => ({
  // --- Layout ---
  main: {
    minHeight: '100vh',
    paddingBottom: theme.spacing(4),
    background: '#fff',
    color: '#263238',
    fontFamily: 'Roboto, sans-serif'
  },
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 20,
    background: '#fff'
  },
  contentArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: 'auto',
    paddingTop: 210,
    paddingBottom: theme.spacing(1)
  },
  stepContainer: {
    width: '100%',
    maxWidth: 1200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingBottom: theme.spacing(6)
  },
  title: {
    fontSize: 22,
    color: '#263238',
    marginBottom: 24,
    width: '100%',
    textAlign: 'center' as const
  },
  subtitle: {
    color: '#65747B',
    marginBottom: theme.spacing(4),
    maxWidth: 620,
    alignSelf: 'center',
    width: '100%',
    textAlign: 'center' as const
  },
  formControl: {
    minWidth: 360,
    maxWidth: 420,
    width: '100%',
    marginBottom: theme.spacing(3)
  },
  guideBox: {
    width: '100%',
    border: '1px solid #eef0f4',
    borderRadius: 12,
    padding: theme.spacing(3),
    textAlign: 'left',
    background: '#fff'
  },


  // --- MonthStep ---
  selectAllBar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    border: '1px solid #e7eaf0',
    borderRadius: 10,
    background: '#f8f9fb'
  },
  groupSection: {
    width: '100%',
    marginTop: theme.spacing(2)
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: '1px solid #eef0f4',
    marginBottom: theme.spacing(1)
  },
  groupName: {
    fontWeight: 700,
    color: '#263238',
    fontSize: 14
  },
  storeList: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  storeCard: {
    border: '1px solid #e7eaf0',
    borderRadius: 10,
    padding: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  disabledStore: {
    opacity: 0.52,
    background: '#f5f6f8'
  },

  // --- ValuesStep ---
  valuesContainer: {
    width: 'calc(100vw - 64px)',
    maxWidth: 1200,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
    textAlign: 'center',
    fontFamily: 'Roboto, sans-serif',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100vw - 32px)'
    }
  },
  valueElement: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%'
  },

  // --- StepActions ---
  actionsContainer: {
    width: '100%',
    maxWidth: 1200,
    margin: `${theme.spacing(1.5)}px auto ${theme.spacing(1)}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  stepActions: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(2)
  },
  stepActionTooltipTarget: {
    marginLeft: 'auto',
    display: 'inline-flex'
  },
  nextButton: {
    fontFamily: 'Roboto, sans-serif',
    marginTop: theme.spacing(1),
    padding: '9px 12px',
    backgroundColor: palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600,
    color: '#fff',
    border: 'none',
    borderRadius: 5,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.4
    }
  },
  // --- GoalStep ---
  sellerAccordionList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    textAlign: 'left'
  },
  sellerAccordionItem: {
    width: '100%',
    border: '1px solid #e7eaf0',
    borderRadius: 12,
    background: '#fff',
    overflow: 'hidden'
  },
  sellerAccordionHeader: {
    width: '100%',
    border: 0,
    background: '#f8f9fb',
    padding: theme.spacing(2),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    color: '#263238',
    fontFamily: 'Roboto, sans-serif',
    textAlign: 'left' as const,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  sellerAccordionTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& strong': {
      fontSize: 15,
      color: '#263238'
    },
    '& span': {
      fontSize: 12,
      color: '#7b8b93'
    }
  },
  sellerAccordionSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    color: '#65747b',
    fontSize: 12,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  },
  sellerStatusOk: {
    color: '#2e7d32',
    background: '#edf7ed',
    borderRadius: 999,
    padding: '4px 8px'
  },
  sellerStatusWarning: {
    color: '#d32f2f',
    background: '#fff0ef',
    borderRadius: 999,
    padding: '4px 8px'
  },
  sellerAccordionContent: {
    padding: theme.spacing(2.5),
    background: '#fff'
  },
  reviewMonthGoal: {
    fontWeight: 700,
    color: palette.primary.main
  },

  // --- ReviewStep ---
  reviewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  reviewCard: {
    border: '1px solid #eef0f4',
    borderRadius: 10,
    padding: theme.spacing(2),
    textAlign: 'left',
    background: '#f8f9fb'
  },
  reviewTableWrapper: {
    width: '100%',
    marginTop: theme.spacing(3),
    border: '1px solid #eef0f4',
    borderRadius: 12,
    overflow: 'hidden',
    background: '#fff'
  },
  reviewTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead tr': {
      background: '#f8f9fb'
    },
    '& th': {
      padding: '14px 18px',
      textAlign: 'left',
      fontSize: 12,
      fontWeight: 600,
      color: '#546e7a',
      borderBottom: '1px solid #eef0f4'
    },
    '& td': {
      padding: '16px 18px',
      textAlign: 'left',
      fontSize: 13,
      color: '#334148',
      borderBottom: '1px solid #eef0f4',
      verticalAlign: 'top'
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none'
    },
    '& tbody tr:nth-child(even)': {
      background: '#fcfcfd'
    }
  },
  reviewStoreName: {
    display: 'flex',
    flexDirection: 'column',
    '& strong': {
      fontSize: 13,
      color: '#263238'
    },
    '& span': {
      marginTop: 4,
      fontSize: 12,
      color: '#7b8b93'
    }
  },
  reviewProfilesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75)
  },
  reviewProfileItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: '4px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  reviewProfileName: {
    fontWeight: 600,
    color: '#334148',
    fontSize: 12,
    lineHeight: 1.15,
    textAlign: 'left' as const
  },
  reviewProfileValues: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#546e7a',
    fontSize: 12,
    whiteSpace: 'nowrap' as const,
    '& strong': {
      color: '#1D5FA7',
      fontSize: 13
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  },

  // --- Sidebar ---
  sideBar: {
    '& > div': {
      top: 140,
      marginTop: 0,
      zIndex: 10
    },
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  sideTopInfo: {
    borderBottom: '1px solid #c4c4c4',
    marginBottom: 25,
    paddingBottom: 25,
    '& div': {
      marginBottom: 5,
      display: 'flex',
      alignItems: 'center'
    },
    '& span': {
      color: '#546e7a',
      fontSize: 11,
      fontWeight: 600,
      textTransform: 'uppercase'
    },
    '& strong': {
      color: '#65747b',
      fontSize: 16,
      fontWeight: 600
    }
  },
  sideSection: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 22,
    '& h2': {
      color: '#263238',
      margin: 0,
      fontSize: 18
    },
    '& span': {
      color: 'rgba(101, 116, 123, 0.6)',
      fontSize: 14,
      marginTop: 10
    },
    '& .filled': {
      color: '#65747B'
    }
  },

  // --- CreationResultDialog ---
  creationDialog: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(520px, calc(100vw - 32px))',
    maxHeight: 'calc(100vh - 48px)',
    overflow: 'auto',
    borderRadius: 14,
    background: '#fff',
    boxShadow: '0 20px 60px rgba(38, 50, 56, 0.22)',
    padding: theme.spacing(4),
    textAlign: 'center' as const,
    outline: 'none'
  },
  creationDialogIcon: {
    width: 58,
    height: 58,
    margin: '0 auto 18px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f4f7fb'
  },
  creationDialogTitle: {
    margin: 0,
    color: '#263238',
    fontSize: 22,
    fontWeight: 700
  },
  creationDialogText: {
    marginTop: theme.spacing(1),
    color: '#65747b',
    fontSize: 14,
    lineHeight: 1.5
  },
  creationDialogErrors: {
    margin: `${theme.spacing(3)}px 0 0`,
    padding: 0,
    listStyle: 'none',
    textAlign: 'left' as const
  },
  creationDialogErrorItem: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: 8,
    border: '1px solid #f2d4d0',
    background: '#fff8f7',
    color: '#546e7a',
    fontSize: 13,
    '& strong': {
      display: 'block',
      marginBottom: 4,
      color: '#263238'
    }
  },
  creationDialogButton: {
    fontFamily: 'Roboto, sans-serif',
    marginTop: theme.spacing(3),
    padding: '10px 16px',
    backgroundColor: palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600,
    color: '#fff',
    border: 'none',
    borderRadius: 5,
    cursor: 'pointer'
  }
}))

export default useBulkGoalStyles
